const btnConfs = {
	终止: { icon: 'warning', ui: 'action decline alt' },
	中止: { icon: 'reply', ui: 'action decline alt' }
}

export default btnConfs